<template>
  <el-container>
    <el-main class="main">
      <div class="admin">
        <el-link type="info" href="/manage">Admin</el-link>
      </div>
      <el-row>
        <Headline />
        <el-row :gutter="20">
          <el-col
            :xs="24"
            :sm="12"
            :md="8"
            :lg="4"
            v-for="(template, index) in templates"
            :key="index"
          >
            <TemplateTile :template="template" />
          </el-col>
        </el-row>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import { mapActions } from 'vuex';
import Headline from '../components/Home/Headline.vue';
import TemplateTile from '../components/Home/TemplateTile.vue';

export default {
  name: 'Home',
  data() {
    return {
      error: false,
      loading: true,
      templates: [],
    };
  },
  mounted() {
    this.getTemplates()
      .then((templates) => {
        this.loading = false;
        this.templates = templates.data;
      })
      .catch(() => {
        this.error = true;
        this.loading = false;
      });
  },
  methods: {
    ...mapActions('creator', ['getTemplates']),
  },
  components: {
    Headline,
    TemplateTile,
  },
};
</script>

<style lang="less" scoped>
p {
  max-width: 500px;
  margin: 15px auto 30px;
  color: rgb(146, 146, 146);
}

.el-row {
  width: 100%;
}

.el-main.main {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  .admin {
    position: absolute;
    top: 20px;
    right: 20px;
  }
}
</style>
